import { render, staticRenderFns } from "./imgU.vue?vue&type=template&id=7804efee&scoped=true"
var script = {}
import style0 from "./imgU.vue?vue&type=style&index=0&id=7804efee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7804efee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7804efee')) {
      api.createRecord('7804efee', component.options)
    } else {
      api.reload('7804efee', component.options)
    }
    module.hot.accept("./imgU.vue?vue&type=template&id=7804efee&scoped=true", function () {
      api.rerender('7804efee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgU.vue"
export default component.exports